import { Dispatch, SetStateAction } from 'react';
import { startCase } from 'lodash';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IContextualMenuItem } from '@fluentui/react';

/**
 * List generator for jump-to menu on the vuln details page.
 *
 * This does a just-in-time list generation, in case the page changes 🙃
 */
export const useJumpToOnMenuOpenedFunction = ({
  setItems,
}: {
  setItems: Dispatch<SetStateAction<IContextualMenuItem[] | undefined>>;
}) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const [t] = useTranslation(['vulnerability']);

  return () => {
    const navItems = Array.from(
      document.querySelectorAll('.ms-DefaultCard[id]')
    );

    const menuItems: IContextualMenuItem[] = navItems
      .map(item => {
        const id = item.id;
        const url = `${pathname}#${id}`;
        const i18nText = t(`${id}.${startCase(id)}`, {
          defaultValue: '',
          ns: 'vulnerability',
        });

        return {
          text: i18nText,
          key: i18nText,
          onClick: () => history.push(url),
        } as IContextualMenuItem;
      })
      .filter(w => w.text && w.text.length > 0);
    setItems(menuItems);
  };
};
